/* eslint-disable default-param-last */
import * as types from './types';

const initialState = {
  isLoading: false,
  data: [],
  selectedOrganizationData: null,
};
const DealSubmissionReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SET_LOADING:
    case types.SET_BUYERS_REPORT_DATA:
    case types.SET_SELECTED_ORGANIZATION_DATA:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default DealSubmissionReducer;
